export default __webpack_public_path__ + "static/media/GU.30ee22fa.mp3";